import { FormField } from '@/components/forms';
import { Input } from '@/components/ui/input';
import type { TriggerAction } from '../../types';

interface StatusFormProps {
  action: TriggerAction;
  onChange: (patch: Partial<TriggerAction>) => void;
}

/**
 * StatusForm
 * 
 * Форма действия изменения статуса
 * 
 * @returns {React.ReactElement} React компонент
 */
export function StatusForm({ action, onChange }: StatusFormProps) {
  return (
    <FormField
      label="Новый статус"
      name="status"
      hint="Например: PAID, CANCELLED, ACTIVE"
    >
      <Input
        value={action.status ?? ''}
        onChange={(e) => onChange({ status: e.target.value || undefined })}
        placeholder="PAID"
      />
    </FormField>
  );
}
